/**
 * Money form of a Langfuse-derived run cost, shared by every surface that
 * renders one (the workflows table, the chat run card, the schedules run
 * panel) so the same run reads the same everywhere.
 *
 * Returns `undefined` when there is no figure, which is not the same as free:
 * callers choose their own wording for unknown.
 *
 * Two decimals is a product decision, not a limit of the data — the API keeps
 * four, so sub-cent runs (a cheap scheduled run lands near $0.002) still sum
 * correctly anywhere costs are aggregated. Only this display rounds them to
 * $0.00.
 */
export function formatRunCost(costUsd?: number | null): string | undefined {
  return typeof costUsd === 'number' ? `$${costUsd.toFixed(2)}` : undefined;
}
